import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainView from "./MainView";
import CitajteoCommon from "./CitajteoCommon";
import { AddNavigationProvider } from "common/modal/AddNavigation";
import CitajteoStart from "components/pages/common/CitajteoStart";
import AboutProject from "../pages/common/AboutProject";
import Copyright from "components/pages/common/Copyright";
import Artists from "components/pages/common/Artists";
import ArtisticMovementsAndPhenomena from "components/pages/common/ArtisticMovementsAndPhenomena";
import LoginView from "./LoginView";
import Login from "components/pages/authentication/Login";
import Logout from "components/pages/authentication/Logout";
import GroupIntroduction from "components/pages/dl_group/GroupIntroduction";
import GroupUTypeUnits from "components/pages/dl_group/GroupUTypeUnits";
import GroupPhotoSeries from "components/pages/dl_group/GroupPhotoSeries";
import UnitSearch from "components/pages/UnitSearch/UnitSearch";

export default function CitajteoMainContent() {
  return (
    <CitajteoCommon>
      <Router>
        <AddNavigationProvider>
          <Routes>
            <Route element={<MainView />}>
              <Route path="/" element={<CitajteoStart />} />
              <Route path="/about" element={<AboutProject />} />
              <Route path="/copyright" element={<Copyright />} />
              <Route path="/artists" element={<Artists />} />
              <Route
                path="/art-movements-and-phenomena"
                element={<ArtisticMovementsAndPhenomena />}
              />
              <Route path="/g">
                <Route path=":slug" element={<GroupIntroduction />}></Route>
                <Route
                  path=":slug/:uType"
                  element={<GroupUTypeUnits />}
                ></Route>
                <Route
                  path=":slug/photo-series/:seriesType"
                  element={<GroupPhotoSeries />}
                ></Route>
              </Route>
              <Route path="/search" element={<UnitSearch />} />
            </Route>

            <Route element={<LoginView />}>
              <Route path="/l-in" element={<Login />} />
              <Route path="/l-out" element={<Logout />} />
            </Route>
          </Routes>
        </AddNavigationProvider>
      </Router>
    </CitajteoCommon>
  );
}
